import { connect } from 'react-redux';
import TaxInputs from './TaxInputs';

import {
    setInstallYear,
    setTaxRate,
    setTaxEntity,
    setResiToggle,
} from '../../common/tax/actions';
import { setShowOBS } from '../../common/obs/actions';
import { setShowPPA } from '../../common/ppa/actions';
import { setShowCAP } from '../../common/cap/actions';
import { setLoanProvider } from '../../common/loan/actions';

import { setTaxInputIsVisible } from './actions';

const mapStateToProps = state => ({
    installYear: state.tax.installYear,
    taxRate: state.tax.taxRate,
    isLocked: state.isLockedUI.isLocked,
    isVisible: state.taxInputsUI.isVisible,
    taxEntity: state.tax.taxEntity,
    resiToggle: state.tax.resiToggle,
    setResiToggle,
    setTaxEntity,
    setInstallYear,
    setTaxInputIsVisible,
    setTaxRate,
    setShowOBS,
    setShowPPA,
    setShowCAP,
    setLoanProvider,
});

const combinedActions = {
    setInstallYear,
    setTaxInputIsVisible,
    setTaxRate,
    setTaxEntity,
    setResiToggle,
    setShowOBS,
    setShowPPA,
    setShowCAP,
    setLoanProvider,
};

export default connect(mapStateToProps, combinedActions)(TaxInputs);



// WEBPACK FOOTER //
// ./src/containers/Inputs/TaxInputs/index.js